module.exports = __webpack_public_path__ + "static/media/comunicacion.02bfdbfc.pdf";